enum ConvertType {
    STRING,
    BOOLEAN,
    NUMBER,
    INTEGER,
    BIGINTEGER,
    FLOAT,
    ARRAY,
    OBJECT
};

function convertTo<T>(value: any = null, type: ConvertType|string, defaultValue: any = null): string | boolean | number | bigint | any[] | T | undefined {
    let convertedValue: string | boolean | number | bigint | any[] | T | undefined;
    switch(type) {
        case ConvertType.STRING:
        case 'string':
            convertedValue = typeof(value) == 'string' ? value : value.toString();
            break;
        case ConvertType.BOOLEAN:
        case 'boolean':
            convertedValue = (value === true || value === 'TRUE' || value === 'true' || value === '1' || value === 1) ? true : false;
            break;
        case ConvertType.NUMBER:
        case 'number':
            convertedValue = Number(value);
            break;
        case ConvertType.INTEGER:
        case 'int':
        case 'integer':
            convertedValue = parseInt(value);
            break;
        case ConvertType.BIGINTEGER:
        case 'bigint':
            convertedValue = BigInt(value);
            break;
        case ConvertType.FLOAT:
            convertedValue = parseFloat(value);
            break;
        case ConvertType.ARRAY:
            if(typeof(value) === 'object') {
                if(Array.isArray(value)) {
                    convertedValue = value;
                } else {
                    convertedValue = [];
                    Object.keys(value).forEach((key: string) => {
                        (convertedValue as any[]).push(value[key]);
                    });
                }
            } else {
                convertedValue = [ value ];
            }
            break;
        default:
            throw 'Can not convert type of value into type of '+type+'.';
            break;
    }
    if(convertedValue == null && defaultValue != null) {
        convertedValue = defaultValue;
    }

    return convertedValue;
}

function cloneObject(obj: any, visited: WeakMap<any, any> = new WeakMap()) {
    if(obj === null || typeof obj !== 'object') {
        return obj;
    }

    if(visited.has(obj)) {
        return visited.get(obj);
    }

    if(obj instanceof Date) {
        return new Date(obj);
    }

    if (obj instanceof RegExp) {
        return new RegExp(obj);
    }

    const clone: any = Array.isArray(obj) ? [] : {};

    visited.set(obj, clone);

    for(const key in obj) {
        if(obj.hasOwnProperty(key)) {
            if(typeof obj[key] === 'function') {
                if(/^\s*class\s+/.test(obj[key].toString())) {
                    clone[key] = obj[key];
                } else {
                    clone[key] = obj[key].bind(clone);
                }
            } else {
                clone[key] = cloneObject(obj[key], visited);
            }
        }
    }

    return clone;
}


function assignTyped<T>(baseConfig: T, source?: { [key: string] : any; }, defaultConfig?: { [key: string] : any; }, strict?: boolean): T {
    const baseConf = cloneObject(baseConfig);
    const cfg = cloneObject(source);
    let converted: { [key: string] : any; } = baseConf;
    if(cfg != null) {
        for(const k in cfg) {
            let value = cfg[k];
            if((typeof(value) === 'undefined' || value === null || value === '') && defaultConfig && defaultConfig[k]) {
                value = defaultConfig[k];
            } else if((typeof(value) === 'undefined' || value === null) && baseConf && baseConf[k] && baseConf[k] !== null) {
                value = baseConf[k];
            }
            if(
                typeof(value) === 'undefined'
                || (
                    typeof(strict) !== 'undefined'
                    && strict
                    && typeof(baseConf[k]) === 'undefined'
                )
            ) {
                continue;
            }
            if(typeof(baseConf[k]) !== 'undefined' && typeof(value) !== 'undefined' && value !== null) {
                if(typeof(baseConf[k]) == 'object') {
                    value = assignTyped(baseConf[k], value, ((defaultConfig && defaultConfig[k]) ? defaultConfig[k] : null), strict);
                } else {
                    value = convertTo(value, typeof(baseConf[k]), value);
                }
            }


            converted[k] = value;
        }
    }

    return converted as T;
}

export { convertTo, assignTyped, cloneObject, ConvertType };
